var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-f_linkedin"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "f_linkedin",
    clipPath: "url(#clip-f_linkedin)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_1180",
    "data-name": "Gruppe 1180",
    transform: "translate(-1068 -954)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Differenzmenge_1",
    "data-name": "Differenzmenge 1",
    d: "M15,30A15,15,0,0,1,4.394,4.393,15,15,0,0,1,25.607,25.607,14.9,14.9,0,0,1,15,30Zm2.777-15.027c1.617,0,1.617,1.532,1.617,2.651V22.5h3.1l0-5.5c0-2.474-.451-4.764-3.726-4.764a3.284,3.284,0,0,0-2.942,1.617h-.044V12.485H12.805V22.5h3.107V17.541C15.912,16.271,16.134,14.973,17.777,14.973ZM7.748,12.485V22.5h3.11V12.485ZM9.3,7.5a1.809,1.809,0,1,0,1.8,1.8A1.8,1.8,0,0,0,9.3,7.5Z",
    transform: "translate(1069 955)",
    fill: "#383e4e"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.bd18bd48892b23fbe1da25e1c017eeaf.svg";
export { ForwardRef as ReactComponent };